// Lightweight toast/snackbar feedback (spec §13 "Notifications and feedback").
let toastTimer: number | undefined;

export function toast(msg: string): void {
  const t = document.getElementById('toast');
  const m = document.getElementById('toastMsg');
  if (!t || !m) return;
  m.textContent = msg;
  t.classList.add('show');
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => t.classList.remove('show'), 2200);
}
